module.exports = __webpack_public_path__ + "static/media/bolis.c6356476.jfif";